import { useSite } from "@/context/SiteContext";
import { MessageCircle, Phone } from "lucide-react";

export default function FloatingActions() {
  const { settings } = useSite();
  const wa = settings.whatsapp || "393331512490";
  const phone = settings.phone || "333 1512490";
  const waLink = `https://wa.me/${wa}?text=${encodeURIComponent(
    "Salve, vorrei informazioni riservate riguardo Afrodite Club Privé e Spa."
  )}`;

  return (
    <div className="fixed bottom-4 right-4 sm:bottom-5 sm:right-5 z-40 flex flex-col gap-2.5 sm:gap-3">
      <a
        data-testid="floating-whatsapp-btn"
        href={waLink} target="_blank" rel="noopener noreferrer"
        className="group flex items-center justify-center gap-2 w-12 h-12 sm:w-auto sm:h-auto sm:pl-4 sm:pr-5 sm:py-3 rounded-full bg-[#25D366] text-black font-semibold shadow-xl hover:scale-105 transition-transform duration-300"
      >
        <MessageCircle className="w-5 h-5" />
        <span className="hidden sm:inline text-sm">WhatsApp</span>
      </a>
      <a
        data-testid="floating-call-btn"
        href={`tel:+39${(settings.phone || "3331512490").replace(/\s/g, "")}`}
        className="group flex items-center justify-center gap-2 w-12 h-12 sm:w-auto sm:h-auto sm:pl-4 sm:pr-5 sm:py-3 rounded-full bg-[#7A1426] text-[#FBF8F5] font-semibold shadow-xl border border-[#D4AF37]/40 hover:scale-105 hover:bg-[#941B30] transition-all duration-300"
      >
        <Phone className="w-5 h-5" />
        <span className="hidden sm:inline text-sm">{phone}</span>
      </a>
    </div>
  );
}
